import {Injectable} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
// RxJS
import {BehaviorSubject, Subject} from 'rxjs';
// NGRX
import {select, Store} from '@ngrx/store';

import {Product} from 'src/app/shared/classes/product';
import {CartItem} from 'src/app/shared/classes/cart-item';
import {ApiService} from './api.service';
import {AuthenticationService} from './authentication.service';
import {User} from '../classes/app.models';
import {cartItemsSelector} from '../../core/selectors/selectors';
import { BudgetService } from './budget.service';
import { ExclusiveService } from './exclusive.service';

@Injectable({
    providedIn: 'root'
})

export class CartService {

    public cartItems: CartItem[] = [];
    // public cartStream: Subject<any> = new BehaviorSubject([]);
    // public qtyTotal: Subject<number> = new BehaviorSubject(0);
    // public priceTotal: Subject<number> = new BehaviorSubject(0);
    private currentUser: any;

    constructor(private store: Store<any>, private toastrService: ToastrService, private apiService: ApiService,
                public authenticationService: AuthenticationService,
            private budgetService: BudgetService,
        private exclusiveService: ExclusiveService) {
        this.authenticationService.currentUser?.subscribe(x => this.currentUser = x);

        // store.pipe(select(cartItemsSelector)).subscribe(items => {
        //     this.cartItems = items;
        //
        //     this.cartStream.next(items);
        //
        //     this.qtyTotal.next(
        //         this.cartItems.reduce((acc, cur) => {
        //             return acc + cur.qty;
        //         }, 0));
        //
        //     this.priceTotal.next(
        //         this.cartItems.reduce((acc, cur) => {
        //             return acc + cur.sum;
        //         }, 0)
        //     );
        // });
    }

    public getCartList() {
        if (this.currentUser && this.currentUser.id > 0) {
            // if(this.currentUser.user_type == 'EXCLUSIVE'){
            //     this.exclusiveService.getCartList(this.currentUser?.customers_id).subscribe((data:any) => {
            //         this.addToApiService(data['data']);
            //     });
            // }else{
                this.apiService.getCartList(this.currentUser?.customers_id).subscribe((data:any) => {
                    this.addToApiService(data['data']);
                });
            // }
        }
    }

    public addToApiService(cartItems) {
        this.apiService.Data.cartList = cartItems && cartItems.imagesArray ? cartItems?.imagesArray : [];
        this.apiService.Data.totalCartCount = cartItems && cartItems.imagesArray ? cartItems.imagesArray.length  : 0;

        this.apiService.Data.totalPrice = 0;
        cartItems?.imagesArray.forEach(product => {
            this.apiService.Data.totalPrice += +product.price;

        });

    }

    // Product Add to Cart
    public addToCart(product: Product, qty = 1) {
        if (!this.isInCart(product)) {
            this.apiService.addToCartListDB(JSON.stringify(product)).subscribe(data => {
                if (data.statusCode === 200) {
                    // this.store.dispatch(new AddToCartAction({product, qty}));
                    this.addToApiService(data.data);
                    this.toastrService.success('Media added to Cart.');

                } else {
                    this.toastrService.error('Error in adding product to the cart');
                }
            });
        } else {
            this.toastrService.error('Media already exist in cart');

        }
    }

    // Product Removed from the Cart
    public  removeFromCart(product) {
        this.apiService.removeCartProduct(JSON.stringify(product)).subscribe(data => {
            if (data.statusCode === 200) {
                // this.store.dispatch(new RemoveFromCartAction({product}));

                const index: number = this.apiService.Data.cartList.indexOf(product);
                this.apiService.Data.cartList.splice(index, 1);
                this.apiService.Data.totalPrice = this.apiService.Data.totalPrice - +product.price;
                this.apiService.Data.totalCartCount = this.apiService.Data.totalCartCount - 1;
                this.toastrService.success('Product removed from Cart.');
            }
        });
    }



    // Remove all products from Cart
    public clearAllCart() {
        this.apiService.removeCartList().subscribe(data => {
            if (data.statusCode === 200) {
                // this.store.dispatch(new ClearAllCartAction({}));
                this.apiService.Data.cartList = [];
                this.apiService.Data.totalPrice = 0;
                this.apiService.Data.totalCartCount = 0;
                this.toastrService.success('Cart Cleared');
            } else {
                this.toastrService.error('Error in clearing cart');
            }
        });
    }


    // Check whether product is in Cart or not
    isInCart(product): boolean {
        return this.apiService.Data.cartList.indexOf(product) > -1 ? true : false;
    }


    // // Cart update
    updateCart(cartItems: CartItem[]) {
        // this.store.dispatch(new UpdateCartAction({cartItems}));
        this.toastrService.success('Cart Updated.');
    }

    // // Check where product could be added to the cart
    canAddToCart(product: Product, qty = 1) {
        // var find = this.cartItems.find(item => item.id == product.id);
        //
        // if (find) {
        //     if (product.stock == 0 || (product.stock && product.stock < (find.qty + qty))) {
        //         return false;
        //     } else {
        //         return true;
        //     }
        // } else {
        //     if (product.stock == 0 || (product.stock && product.stock < qty)) {
        //         return false;
        //     } else {
        //         return true;
        //     }
        // }
        return true;
    }
}
